<template>
  <!-- 区域报备 -->
  <div class="reportApplication">
    <commonHeader :explain="explain" :title="pageTitle" />
    <!-- 基本信息 -->
    <basicInformation
      ref="basicInformationRef"
      v-if="!$route.query.activityCode || editEchoData"
      :edit-echo-data="editEchoData"
    />
    <!-- 费用归属 -->
    <!-- !$route.query.activityCode：表示不是编辑页 -->
    <!-- editEchoData：表示是编辑页并且请求数据成功 -->
    <!-- !needOrganizer：表示没有活动组支持 -->
    <!-- addCostEditFlag：表示活动组支持追加的费用可编辑 -->
    <!-- 活动信息 -->
    <activityInformation
      ref="activityInformationRef"
      v-if="!$route.query.activityCode || editEchoData"
      :edit-echo-data="editEchoData"
      :component-name="componentName"
      :set-cache-list="setCacheList"
      @getIndustryReportActivityCode="(val) => { industryReportActivityCode = val; }"
      @getActivitySource="(val) => { activitySource = val; }"
      @clearCostAscription="handleClearCostAscription"
    />
    <costAscription
      ref="costAscriptionRef"
      v-if="(!$route.query.activityCode || editEchoData) && (!needOrganizer || addCostEditFlag)"
      :edit-echo-data="editEchoData"
      :component-name="componentName"
      :industry-report-activity-code="industryReportActivityCode"
      :activity-source="activitySource"
      @checkAllsmartOrderVOListCommand="handleSuccessAllsmartOrderVOList"
    />
    <!-- 重点拟邀请客户 -->
    <userSelection
      ref="userSelectionRef"
      v-if="(!$route.query.activityCode || editEchoData) && isMustWrite()"
      :edit-echo-data="editEchoData"
      :component-name="componentName"
      :cache-list="cacheList"
      :must-write="isMustWrite()"
    />
    <!-- 活动目标 -->
    <activityCatalogue
      ref="activityCatalogueRef"
      v-if="lang === 'zh-CN' && (!$route.query.activityCode || editEchoData)"
      :edit-echo-data="editEchoData"
      :cache-list="cacheList"
      report-type="area"
    />
    <!-- 活动附件 -->
    <activityFile
      ref="activityFileRef"
      v-if="(!$route.query.activityCode || editEchoData) && !componentName"
      :edit-echo-data="editEchoData"
    />
    <!-- 转申请操作按钮 -->
    <!-- <div class="buttons" v-if="$route.path === '/editRegionReportApplication'">
      <el-button plain @click="cancelReport">{{ $t('btn.CancelFil') }}</el-button>
      <el-button type="primary" @click="submitBtn">{{ $t('btn.TransferApp') }}</el-button>
    </div> -->
    <!-- 报备申请按钮 -->
    <div class="buttons" v-if="$route.path !== '/regionReportTransferApplication'">
      <el-button plain @click="saveBtn" v-if="saveBtnShow">{{ $t('btn.SaveD') }}</el-button>
      <el-button type="primary" @click="submitBtn">{{ $t('btn.Submit') }}</el-button>
    </div>
  </div>
</template>

<script>
import commonHeader from '@/components/commonHeader';
import basicInformation from './component/newApplicationForm/basicInformation';
import activityInformation from './component/newApplicationForm/regionActivityInformation.vue';
import userSelection from './component/newApplicationForm/industryUserSelection.vue';
import costAscription from './component/newApplicationForm/regionCostAscription.vue';
import { hasAllsmartOrder, confirmAllsmartOrderTimeout } from '@/utils/allsmartOrderCheck';
import { confirmPrecheck, confirmBusiness, notifyDetectFailed } from '@/utils/exportComplianceDialog';
import activityFile from './component/newApplicationForm/activityFile';
import activityCatalogue from './component/newApplicationForm/industryActivityCatalogue.vue';
import { newApplicationFormApi } from './service';
import { mapState } from 'vuex';
import {isNotEmpty, throttle, throttleAsync} from '../../utils/utils';

export default {
  data () {
    return {
      componentName: 'industryReportApplication',
      pageTitle: this.$t('home.aff'),
      explain: {
        text: `${this.$t('notic.AppRule')}，`,
        content: this.$t('notic.AppRuleOne')
      },
      editEchoData: null,
      addCostEditFlag: false, // 活动组支持追加的费用是否可编辑
      saveBtnShow: false,
      isSubmitted: false, // 是否已提交：false离开页面会有提示保存信息
      lang: localStorage.getItem('lang') || 'zh-CN',
      cacheList: {}, // 缓存数据，用于活动目标组件使用
      industryReportActivityCode: '', // 关联模板活动的活动编码
      activitySource: null // 活动来源
    };
  },
  computed: {
    ...mapState({
      needOrganizer: (state) => state.newApplication.needOrganizer
    })
  },
  components: {
    commonHeader,
    basicInformation,
    activityInformation,
    userSelection,
    costAscription,
    activityFile,
    activityCatalogue
  },
  methods: {
    // 清除费用归属数据
    handleClearCostAscription () {
      if (this.$refs.costAscriptionRef) {
        this.$refs.costAscriptionRef.deptRelyChangeClear();
      }
    },
    setCacheList (key, value) {
      this.$set(this.cacheList, key, value);
    },
    isMustWrite () {
      if (!this.$refs.activityInformationRef?.formData.marketingForm) return false;
      return this.$refs.activityInformationRef?.formData.marketingForm === '1';
    },
    cancelReport () {
      this.$confirm(this.$t('newApp.Ycon'), this.$t('general.Hint'), {
        confirmButtonText: this.$t('btn.OK'),
        cancelButtonText: this.$t('btn.Cancel'),
        type: 'warning'
      }).then(() => {
        newApplicationFormApi.cancelReport(this.$route.query.activityCode).then(res => {
          if (res.status === '200') {
            this.$message.success(this.$t('general.OperSucc'));
            this.$router.push('/reportList');
          }
        });
      }).catch(() => {
      });
    },
    paramsHandler (saveType) {
      // saveType 保存类型 1-草稿  2-提交  3-品推编辑  4-驳回编辑  5-报备提交   6-报备草稿   7-报备编辑  8-报备转申请

      let params = {
        // 保存类型
        saveType: saveType
      };
      // 基本信息
      let basicInfoData = this.$refs.basicInformationRef.formData;

      // 活动信息
      let activityInfoData = this.$refs.activityInformationRef.formData;
      let activityCatalogueData = this.$refs.activityCatalogueRef?.formData;
      params.marketActivity = {
        // submitType 提交类型(页面类型) quick_submit-快速提交  普通提交-normal_submit  报备提交-report_submit  渠道提交-qd_submit
        submitType: 'report_submit',
        // 基本信息
        activityCode: basicInfoData.activityCode,
        financialSystemCode: basicInfoData.financialSystemCode,
        financialSystemName: basicInfoData.financialSystemName,
        currencyCode: basicInfoData.currencyCode,
        currencyType: basicInfoData.currencyType,
        currFromRmbRate: basicInfoData.currFromRmbRate,
        applyUserTel: basicInfoData.applyUserTel,
        applyTime: basicInfoData.applyTime,
        salerId: basicInfoData.salerId,
        salerName: basicInfoData.salerName,
        salerDeptCode: basicInfoData.salerDeptCode,
        salerDeptName: basicInfoData.salerDeptName,
        applyUserId: basicInfoData.applyUserId,
        applyUserName: basicInfoData.applyUserName,
        applyUserDeptCode: basicInfoData.applyUserDeptCode,
        applyUserDeptName: basicInfoData.applyUserDeptName,
        applyUserType: basicInfoData.applyUserType,
        // 活动信息
        activityName: activityInfoData.activityName,
        activityGoal: '市场活动类',
        businessUnit: activityInfoData.businessUnitDisplayed ? activityInfoData.businessUnitDisplayed.join(',') : '',
        // businessUnit: activityInfoData.businessUnitDisplayed,
        activityClassificationCode: activityInfoData.activityClassificationCode,
        activityClassification: activityInfoData.activityClassification,
        relatedActivityCode: activityInfoData.relatedActivityCode,
        relatedActivityName: activityInfoData.relatedActivityName,
        hqActivityCode: activityInfoData.relatedActivityCode,
        hqActivityName: activityInfoData.hqActivityName,
        activityForms: activityInfoData.activityForms,
        organizer: activityInfoData.organizer,
        // inviterNum: activityInfoData.inviterNum,
        targetObject: activityInfoData.targetObject,
        targetObjectOther: activityInfoData.targetObjectOther || '',
        activityTypeCode: activityInfoData.activityTypeCode,
        activityType: activityInfoData.activityType,
        qdMeetingSegment: activityInfoData.qdMeetingSegment,
        city: activityInfoData.city,
        expectStartDate: activityInfoData.expectStartDate,
        expectEndDate: activityInfoData.expectEndDate,
        isUnionMarket: activityInfoData.isUnionMarket,
        isInternationalQd: activityInfoData.isInternationalQd,
        unionChannelType: activityInfoData.unionChannelType,
        unionChannelName: activityInfoData.unionChannelName,
        needOrganizer: activityInfoData.needOrganizer,
        budgetAmount: activityInfoData.budgetAmount,
        organizerReason: activityInfoData.organizerReason,
        isNationalRelease: activityInfoData.isNationalRelease,
        reportType: '1', // （1-区域报备 2-行业报备）
        reportStat: '2', // 报备状态
        inviterNum: activityCatalogueData?.zrs,
        // 邀请单位数：从活动目录数据中获取的单位数(dws)
        invitedUnitNum: activityCatalogueData?.dws,
        // 新业务机会数：从活动目录数据中获取的3个月内可能产生的新业务机会数量(create3m)
        newOpptyNum: activityCatalogueData?.create3m,
        // 推动业务机会数：从活动目录数据中获取的3个月内可能推动的业务机会数量(push3m)
        pushOpptyNum: activityCatalogueData?.push3m,
        // 新业务机会金额
        newOpptyAmount: activityCatalogueData?.create3mAmount || 0,
        // 推动业务机会金额
        pushOpptyAmount: activityCatalogueData?.push3mAmount || 0,
        industryReportActivityCode: this.industryReportActivityCode // 关联模板活动的活动编码
      };
      if (isNotEmpty(activityInfoData.mactCommunicationScenarioList)) {
        params.mactCommunicationScenarioList = activityInfoData.mactCommunicationScenarioList;
      }
      if (isNotEmpty(activityInfoData.mactAgendaList)) {
        params.mactAgendaList = activityInfoData.mactAgendaList;
      }
      // 活动信息-扩展表（后续新增的字段）
      params.marketActivityExpand = {
        activityCode: basicInfoData.activityCode,
        brandPromotionSupportKey: activityInfoData.brandPromotionSupportKey,
        brandPromotionSupport: activityInfoData.brandPromotionSupport,
        remotePoc: activityInfoData.remotePoc,
        unitedDiamondActivity: activityInfoData.unitedDiamondActivity,
        circleActivity: activityInfoData.circleActivity,
        templateVisit: activityInfoData.templateVisit,
        machineDemo: activityInfoData.machineDemo,
        activityBaseName: activityInfoData.activityBaseName,
        activityBaseContactInformation: activityInfoData.activityBaseContactInformation,
        activityBaseUrl: activityInfoData.activityBaseUrl,
        activityBaseDeptCode: activityInfoData.activityBaseDeptCode,
        activityBackgroundPurpose: activityInfoData.activityBackgroundPurpose,
        marketingForm: activityInfoData.marketingForm,
        targetIndustry: activityInfoData.targetIndustry,
        reportCircleActivity: activityInfoData.circleActivity, // 转申请-是否为圈活动
        reportTemplateVisit: activityInfoData.templateVisit, // 转申请-是否为模板活动
        reportMachineDemo: activityInfoData.machineDemo, // 转申请-是否为样机演示/体验
        reportExpectEndDate: activityInfoData.expectEndDate, // 转申请-预计结束时间
        reportUnitedDiamondActivity: activityInfoData.unitedDiamondActivity, // 转申请-是否为联合精钻活动
        reportRemotePoc: activityInfoData.remotePoc // 转申请-是否为远程POC
      };

      // 活动预计包含板块
      params.mactModuleList = this.$refs.activityInformationRef.plateFilter();

      // 产品线
      params.mactProductLineList = this.$refs.activityInformationRef.productlineSupplementFilter();

      // 拟邀客户
      params.mactJoinCustomerList = this.$refs.userSelectionRef ? this.$refs.userSelectionRef.getTableData() : [];
      if (isNotEmpty(params.mactJoinCustomerList)) {
        params.mactJoinCustomerList.forEach(item => {
          item.phone = item.telephone;
          item.mustFollowCustomer = item.mustFollowC;
          if (Array.isArray(item.opportunityName)) {
            item.opportunityName = item.opportunityName.join(',');
          } else if (typeof item.opportunityName === 'string') {
            // already a string, do nothing
          } else {
            item.opportunityName = '';
          }
        });
      }
      // 费用归属
      // 如果不是活动组支持 || 是活动组支持追加的费用可编辑
      if ((!this.needOrganizer || this.addCostEditFlag) && this.$refs.costAscriptionRef) {
        const pathList = ['/regionReportApplication', '/editRegionReportApplication'];
        const getRowTemplateCost = this.$refs.costAscriptionRef.getRowTemplateCost;
        params.mactExpenseBelongVOList = this.$refs.costAscriptionRef.tableData.map(item => {
          return {
            mactExpenseBelong: {
              ...item,
              activityCode: basicInfoData.activityCode,
              activityType: 2,
              reportType: 1, // （1-区域报备 2-行业报备）
              reportApplyAmount: (item.reportApplyAmount * 1) ? (item.reportApplyAmount * 1).toFixed(2) : 0,
              // 如果是转申请则报备申请金额不能修改，则取后台返回的金额
              // reportApplyAmount: this.$route.path === '/editRegionReportApplication' ? item.reportApplyAmount : item.activityCost
              applyAmount: pathList.includes(this.$route.path) ? item.reportApplyAmount : item.applyAmount ? item.applyAmount : 0,
              industryReportActivityCode: getRowTemplateCost(item) ? this.industryReportActivityCode : '' // 关联模板活动的活动编码
            },
            activityExpenseDetails: item.activityExpenseDetails,
            advertiseExpenseDetails: item.advertiseExpenseDetails,
            allsmartOrderVOList: item.allsmartOrderVOList
          };
        });
        // 费用归属总计
        const costAscriptionRef = this.$refs.costAscriptionRef;
        params.marketActivity.totalCost = this.editEchoData && this.$route.path === '/regionReportTransferApplication' ? costAscriptionRef.getCostTotal() : costAscriptionRef.getReportApplyAmount() * 1;
      } else {
        params.mactExpenseBelongVOList = [];
      }

      // 活动附件
      // if (this.$refs.activityFileRef.fileList.length > 0) {
      //   params.attachFileList = this.$refs.activityFileRef.fileList.map(item => {
      //     return {
      //       fileId: item.response ? item.response.data[0].FID : item.fileId,
      //       fileName: item.name,
      //       activityCode: basicInfoData.activityCode,
      //       sourceType: 'Activity'
      //     };
      //   });
      // }
      return params;
    },
    validateScrollJump (ele, scrollbarData) {
      let eleInfo = ele.$el.getBoundingClientRect();
      if (eleInfo.top < 0) {
        scrollbarData.scrollTop = scrollbarData.scrollTop - (eleInfo.height / 2) - Math.abs(eleInfo.top);
      }
    },
    // 提交前校验
    async subValidate () {
      let mainScrollbar = document.querySelector('.contentScrollbar>.el-scrollbar__wrap');

      // 基本信息校验
      let basicInfoValidate = await this.$refs.basicInformationRef.validateHandler();
      if (!basicInfoValidate) {
        this.validateScrollJump(this.$refs.basicInformationRef, mainScrollbar);
        return;
      }

      // 活动信息校验
      let activityInfoValidate = await this.$refs.activityInformationRef.validateHandler();
      if (!activityInfoValidate) {
        this.validateScrollJump(this.$refs.activityInformationRef, mainScrollbar);
        return;
      }
       // 活动目标校验
      let activityCatalogueValidate = await this.$refs.activityCatalogueRef.validateHandler();
      if (!activityCatalogueValidate) {
        this.validateScrollJump(this.$refs.activityCatalogueRef, mainScrollbar);
        return;
      }
      // 费用归属校验
      if (!this.needOrganizer || this.addCostEditFlag) {
        let costValidate = await this.$refs.costAscriptionRef.validateHandler();
        if (!costValidate) {
          this.validateScrollJump(this.$refs.costAscriptionRef, mainScrollbar);
          return;
        };
      }
      // 拟邀请客户校验
      if (this.$refs.userSelectionRef) {
        let userSelectionValidate = await this.$refs.userSelectionRef.validateHandler();
        if (!userSelectionValidate) {
          this.validateScrollJump(this.$refs.userSelectionRef, mainScrollbar);
          return;
        }
      }

      // 活动附件校验
      // let fileValidate = await this.$refs.activityFileRef.validateHandler();
      // if (!fileValidate) return;

      return true;
    },
    // 礼品库内容检测
    async checkAllsmartOrderVOList (type) {
        const { dataList } = this.$refs.costAscriptionRef.$refs.costAscriptionTable.tableData;
        dataList.forEach(item => {
            this.$refs.costAscriptionRef.getDetailCommand(item, type);
        });
    },
    // 接口处理事件
    handleSuccessAllsmartOrderVOList: throttleAsync(async function () {
      let validateResult = await this.subValidate();
      if (!validateResult) return;
      let { path } = this.$route;
      let saveType = 5;
      if (path === '/editRegionReportApplication') {
        saveType = 7;
      } else if (path === '/regionReportTransferApplication') {
        saveType = 8;
      }
      // 报备转申请时，礼品汇超时规则确认弹窗
      if (saveType === 8) {
        const { dataList } = this.$refs.costAscriptionRef.$refs.costAscriptionTable.tableData;
        const confirmed = await confirmAllsmartOrderTimeout(this, hasAllsmartOrder(dataList));
        if (!confirmed) return;
      }
      let params = this.paramsHandler(saveType);
      newApplicationFormApi.verificationActivity(params).then(res => {
        confirmPrecheck(this, res, {
          originalBizId: (params.marketActivity && params.marketActivity.activityCode) || ''
        }).then(confirmed => {
          if (confirmed) {
            this.submitRequestCommand(params, path);
          }
        });
      }).catch(() => {
        notifyDetectFailed(this);
      });
    }, 500),
    submitRequestCommand (params, path) {
      console.log(params);
      this.$store.commit('setSubPageLoading', true);
      newApplicationFormApi.reportNewSubmit(params).then(res => {
        this.$store.commit('setSubPageLoading', false);
        confirmBusiness(this, res).then(passed => {
          if (passed) {
            this.isSubmitted = true;
            this.$message.success(this.$t('general.SubSucc'));
            // 如果是转申请，提交成功则跳转至活动列表页
            if (path === '/regionReportTransferApplication') {
              this.$router.push('/activityQuery');
            } else {
              this.$router.push('/regionReportList');
            }
          }
        });
      });
    },
    submitBtn: throttle(function () {
      const routeUrlList = ['/reportApplication', '/editRegionReportApplication'];
      if (!routeUrlList.includes(this.$route.path)) {
        this.checkAllsmartOrderVOList('submit');
      } else {
        this.handleSuccessAllsmartOrderVOList();
      }
    }, 1000),
    saveBtnHandler (type, from) {
      if (this.$refs.activityFileRef) {
        let fileValidate = this.$refs.activityFileRef.validateHandler();
        if (!fileValidate) return;
      }
      let params = this.paramsHandler(6);
      return new Promise((resolve, reject) => {
        newApplicationFormApi.reportNewSubmit(params).then(res => {
          confirmBusiness(this, res).then(passed => {
            if (passed) {
              this.isSubmitted = true;
              this.$message.success(this.$t('general.SaveSucc'));
              if (type === 'next') {
                resolve();
              } else {
                this.$router.push('/drafts');
              }
            } else if (type === 'next') {
              this.$root.$emit('restore-menu-active', from.path);
            }
          });
        }).catch(err => {
          reject(err);
        });
      });
    },
    saveBtn: throttle(function (type, from) {
      return this.saveBtnHandler(type, from);
    }, 1000),
    getEchoData () {
      this.$store.commit('setSubPageLoading', true);
      newApplicationFormApi.getReportData(this.$route.query.activityCode).then(res => {
        this.$store.commit('setSubPageLoading', false);
        if (res.status === '200') {
          const result = JSON.parse(JSON.stringify(res.data));
          if (isNotEmpty(result)) {
            if (isNotEmpty(result.mactJoinCustomerList)) {
              result.mactJoinCustomerList.forEach(item => {
                item.telephone = item.phone;
                item.mustFollowC = item.mustFollowCustomer;
              });
            }
            if (isNotEmpty(result.mactExpenseBelongVOList)) {
              result.mactExpenseBelongVOList = result.mactExpenseBelongVOList.filter(item => item.mactExpenseBelong.stat !== 104);
            }
          };
          this.editEchoData = result;
          // 是否需要活动组支持
          this.$store.commit('newApplication/setNeedOrganizer', result.marketActivity.needOrganizer);
          if (result.marketActivity.needOrganizer) {
            // 活动组支持追加的费用是否可编辑
            // 000 为总部报备活动
            this.addCostEditFlag = result.mactExpenseBelongVOList.some(item => {
              return item.allowEdit && item.mactExpenseBelong.deptCode !== '000';
            });
          }
        }
      });
    }
  },
  mounted () {
    // 保存按钮显示隐藏：如果是申请页面
    this.saveBtnShow = this.$route.path === '/regionReportApplication';

    // 如果申请页面
    // 只有每月的20号-30/31号才可以报备申请
    if (this.$route.path === '/regionReportApplication') {
      let currentDay = new Date().getDate();
      if (currentDay < 1) {
        this.$alert(this.$t('notic.AppNotic'), this.$t('general.Hint'), {
          confirmButtonText: this.$t('btn.OK'),
          showClose: false,
          showCancelButton: false
        }).then(() => {
          this.$router.push('/home');
        }).catch(() => {

        });
      }
    }

    if (this.$route.query.activityCode) {
      this.pageTitle = this.$t('general.ReportEditor');
      this.isSubmitted = true;
      this.getEchoData();
      if (sessionStorage.getItem('applicationEditFlag')) {
        this.$store.commit('newApplication/setEditFlag', Number(sessionStorage.getItem('applicationEditFlag')));
      }
      window.addEventListener('beforeunload', () => {
        sessionStorage.setItem('applicationEditFlag', this.$store.state.newApplication.editFlag);
      });
    }
  },
  beforeRouteLeave (to, from, next) {
    // 如果没有提交并且填写了活动名称，则提示该信息
    if (!this.isSubmitted && this.$refs.activityInformationRef.formData.activityName) {
      this.$confirm(this.$t('general.OKSad'), this.$t('general.Hint'), {
        confirmButtonText: this.$t('btn.OK'),
        cancelButtonText: this.$t('btn.Cancel'),
        distinguishCancelAndClose: true,
        showClose: true,
        type: 'warning'
      }).then(() => {
        this.saveBtnHandler('next', from).then(() => {
          next();
        }).catch(() => {
          this.$root.$emit('restore-menu-active', from.path);
        });
      }).catch((action) => {
        if (action === 'cancel') {
          next();
        } else if (action === 'close') {
          this.$root.$emit('restore-menu-active', from.path);
        }
      });
    } else {
      sessionStorage.removeItem('applicationEditFlag');
      this.$store.commit('newApplication/setEditFlag', 0);
      next();
    }
  }
};
</script>

<style scoped>
.reportApplication .buttons {
  text-align: center;
}
</style>
